<template>
	{{ parseValue(value, settingId, unit) }}
</template>

<script>
import { STAB_PARMS } from '@/app.conf.js'
import {
	// subtractHoursFromNowDate,
	dateTimeToString,
	verboseTimePeriod,
	chartTimeStr,
} from '@/helpers.js'
// import PickPeriodVidget from '@/components/Vidgets/PickPeriodVidget.vue'
import { useAccontStore } from '@/stores/AccountStore'
// import { usePostsStore } from '@/stores/PostsStore.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import { Station } from '@/models/station.js'
import { PowerUnit } from '@/models/powerUnit.js'
import { ServiceUnit } from '@/models/serviceUnit.js'
import { ModemUnit } from '@/models/modemUnit.js'
import { ElectricMeter } from '@/models/electricMeter.js'
import { Breaker } from '@/models/breaker.js'
import { FIELD_NAMES, } from '@/api/api.js'

export default {
	components: {},

	props: {
		stationId: {
			type: String,
			require: true,
		},

		value: {
			// type: [String, Date, Boolean, Object, undefined, null],
			require: true,
		},

		settingId: {
			type: String,
			require: false,
			default: null,
		},

		unit: {
			type: String,
			require: false,
			default: null,
		},
	},

	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()

		return {
			accountStore,
			stationsStore,
			Station,
			FIELD_NAMES,
			dateTimeToString,
			verboseTimePeriod,
		}
	},

	data() {
		return {}
	},

	created() {},

	mounted() {},

	methods: {
		departmentName(departmentId) {
			const department = this.departments.find((el) => el.id == departmentId)
			return department ? department[this.accountStore.schema.organization.departments.title] : null
		},

		sectorName(sectorId) {
			let name = null
			for (const department of this.departments) {
				for (const sector of department[this.accountStore.schema.organization.departments.sectors]) {
					if (sector.id == sectorId) {
						name = sector.title
					}
				}
			}
			return name
		},

		parseValue(value, settingId=null, unit=null) {
			// console.log('parse', value, settingId, unit)
			if (Object.prototype.toString.call(value) === '[object Date]') {
				if (settingId == Station.passportKeys.surveyStartTime) {
					return chartTimeStr(value)
				}
				return dateTimeToString(value)
			} else if (value === true || value === false) {
				return value ? 'так' : 'ні'
			} else if (this.departmentName(value)) {
				return this.departmentName(value)
			} else if (this.sectorName(value)) {
				return this.sectorName(value)
			// If station survey priod
			} else if (
				settingId == Station.passportKeys.surveyPeriod
				&& unit == null
			) {
				return verboseTimePeriod(value)
			// If station potential source
			} else if (
				settingId == Station.passportKeys.potentialSource
				&& unit == null
			) {
				return value === undefined ? 'не задано' : Station.potentialSourceNames[value]
			// If station type
			} else if (
				settingId == Station.passportKeys.stationType
				&& unit == null
			) {
				return value === undefined || Station.types[value]?.title == undefined
					? 'не задано'
					: Station.types[value]?.title
			// If station protection method
			} else if (
				settingId == Station.passportKeys.protectionMethod	
				&& unit == null
			) {
				return value === undefined || Station.protectionMethods[value]?.title == undefined
					? 'не задано'
					: Station.protectionMethods[value]?.title
			// If station stabilization settings
			} else if (
				Object.prototype.toString.call(value) === '[object Object]'
				&& settingId == Station.passportKeys.stabilization.self	
				&& unit == null
			) {
				const stabParm = Object.values(STAB_PARMS)
					.find((el) => el.id == value[Station.passportKeys.stabilization.parameter])
				const stabParmName = stabParm?.name ? stabParm.name : 'невідомий параметр'
				return `${stabParmName} = ${value[Station.passportKeys.stabilization.value]} ${stabParm?.unit}`
			// If related stations list
			} else if (settingId == Station.passportKeys.relatedStations) {
				if (!value) {
					return 'не визначено'
				}

				let promt = ''
				for (const relatedStationId of value) {
					const relatedStation = this.stationsStore.station(relatedStationId)
					
					promt += relatedStation 
						? `${relatedStation.shortName ?? relatedStation.name}, `
						: ' невідома (видалена), '
				}

				return promt.slice(0, promt.length - 2)
			// If station pipeline
			} else if (settingId == Station.passportKeys.pipelineId) {
				const pipelines = this.station?.passport?.get(Station.passportKeys.org)?.pipelines
				return value
					? pipelines.find((el) => el.id == value)?.title
					: 'не задано'
			// If notification distribution settings
			} if (
				Array.isArray(value)
				&& unit == Station.passportKeys.notificationDistributionLists.self	
			) {
				return value.includes(this.accountStore.userId) ? 'так' : 'ні'
			// If power unit version
			} else if (
				unit == Station.passportKeys.powerUnit.self
				&& settingId == Station.passportKeys.powerUnit.unitVersion
			) {
				return PowerUnit.versionNames[value]
			// If service unit version
			} else if (
				unit == Station.passportKeys.serviceUnit.self
				&& settingId == Station.passportKeys.serviceUnit.unitVersion
			) {
				return ServiceUnit.versionNames[value]
			// If service uint security circuit purpose
			} else if (
				unit == Station.passportKeys.serviceUnit.self
				&& [
					Station.passportKeys.serviceUnit.securityCircuit_1_purpose,
					Station.passportKeys.serviceUnit.securityCircuit_2_purpose,
					Station.passportKeys.serviceUnit.securityCircuit_3_purpose,
					Station.passportKeys.serviceUnit.securityCircuit_4_purpose,
					Station.passportKeys.serviceUnit.securityCircuit_5_purpose,
					Station.passportKeys.serviceUnit.securityCircuit_6_purpose,
				].includes(settingId)
			) {
				return ServiceUnit.securityCircuitPurposeNames[value] ?? 'не задано'
			// If service uint security circuit handler
			} else if (
				unit == Station.passportKeys.serviceUnit.self
				&& [
					Station.passportKeys.serviceUnit.securityCircuit_1_handler,
					Station.passportKeys.serviceUnit.securityCircuit_2_handler,
					Station.passportKeys.serviceUnit.securityCircuit_3_handler,
					Station.passportKeys.serviceUnit.securityCircuit_4_handler,
					Station.passportKeys.serviceUnit.securityCircuit_5_handler,
					Station.passportKeys.serviceUnit.securityCircuit_6_handler,
				].includes(settingId)
			) {
				return ServiceUnit.securityCircuitHandlers.find((el) => el.code == value)?.title ?? 'не задано'
			// If electric meter survey period
			} else if (
				unit == Station.passportKeys.electricMeter.self
				&& settingId == Station.passportKeys.electricMeter.surveyPeriod
			) {
				return verboseTimePeriod(value)
			// Electric meter type
			} else if (
				unit == Station.passportKeys.electricMeter.self
				&& settingId == Station.passportKeys.electricMeter.type
			) {
				return ElectricMeter.versionNames[value]
			// If modem unit version
			} else if (
				unit == Station.passportKeys.modemUnit.self
				&& settingId == Station.passportKeys.modemUnit.unitVersion
			) {
				return ModemUnit.versionNames[value]
			// If modem unit grid mode
			} else if (
				unit == Station.passportKeys.modemUnit.self
				&& [Station.passportKeys.modemUnit.allowedGridMode1, Station.passportKeys.modemUnit.allowedGridMode2].includes(settingId)
			) {
				return ModemUnit.allowedGridModeNames.find((el) => el.code == value)?.title ?? 'не задано'
			// If modem unit server name
			} else if (
				unit == Station.passportKeys.modemUnit.self
				&& [Station.passportKeys.modemUnit.allowedServers1, Station.passportKeys.modemUnit.allowedServers2].includes(settingId)
			) {
				return ModemUnit.serverNames.find((el) => el.code == value)?.title ?? 'не задано'
			// If modem unit port speed
			} else if (
				unit == Station.passportKeys.modemUnit.self
				&& [Station.passportKeys.modemUnit.speed1, Station.passportKeys.modemUnit.speed2].includes(settingId)
			) {
				return ModemUnit.portSpeedModeNames.find((el) => el.code == value)?.title ?? 'не задано'
			// If modem unit bit count (data bits)
			} else if (
				unit == Station.passportKeys.modemUnit.self
				&& [Station.passportKeys.modemUnit.bitCount1, Station.passportKeys.modemUnit.bitCount2].includes(settingId)
			) {
				return ModemUnit.dataBitsCountNames.find((el) => el.code == value)?.title ?? 'не задано'
			// If modem unit stop bits count
			} else if (
				unit == Station.passportKeys.modemUnit.self
				&& [Station.passportKeys.modemUnit.stopBit1, Station.passportKeys.modemUnit.stopBit2].includes(settingId)
			) {
				return ModemUnit.stopBitsCountNames.find((el) => el.code == value)?.title ?? 'не задано'
			// If modem unit parity
			} else if (
				unit == Station.passportKeys.modemUnit.self
				&& [Station.passportKeys.modemUnit.parity1, Station.passportKeys.modemUnit.parity2].includes(settingId)
			) {
				return ModemUnit.parityNames.find((el) => el.code == value)?.title ?? 'не задано'
			// If modem unit RTU mode
			} else if (
				unit == Station.passportKeys.modemUnit.self
				&& [Station.passportKeys.modemUnit.convertingRtu1, Station.passportKeys.modemUnit.convertingRtu2].includes(settingId)
			) {
				return ModemUnit.rtuModeNames.find((el) => el.code == value)?.title ?? 'не задано'
			// If breaker version
			} else if (
				unit == Station.passportKeys.breaker.self
				&& settingId == Station.passportKeys.breaker.unitVersion
			) {
				return Breaker.versionNames[value]
			} else if (value === null || value === undefined || value == '') {
				return 'не задано'
			} else {
				return value
			}
		},
	},

	computed: {
		station() { return this.stationsStore.station(this.stationId) },

		stationOrg() {
			return this.station.passport.get(Station.passportKeys.org)
		},

		departments() {
			const org = this.stationOrg
			if (!org) {
				return []
			}

			const deps = org.departments
			if (!deps) {
				return []
			}

			return deps
		},
	},
}
</script>